var map = {
  "./cs.messages.tsx": [
    "20301",
    [
      21398
    ]
  ],
  "./en.messages.tsx": [
    "80911",
    [
      86089
    ]
  ],
  "./sl.messages.tsx": [
    "57968",
    [
      21837
    ]
  ],
  "./hu.messages.tsx": [
    "3740",
    [
      79493
    ]
  ],
  "./de.messages.tsx": [
    "53752",
    [
      91073
    ]
  ],
  "./it.messages.tsx": [
    "91782",
    [
      3883
    ]
  ],
  "./pl.messages.tsx": [
    "53831",
    [
      31564
    ]
  ],
  "./fr.messages.tsx": [
    "27819",
    [
      90072
    ]
  ],
  "./sk.messages.tsx": [
    "97525",
    [
      83726
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 67144;
module.exports = __rspack_async_context;
